import { UntypedFormGroup } from '@angular/forms';
import { LocationResult } from './input-address-search/input-address-search.component';
import { isNullOrUndefined } from '../../shared/utils/is-null-or-undefined';

export class FormEditorBase {

  public form: UntypedFormGroup;

  /**
   * This method will mark as touched all the fields/controls in the FormGroup.
   * So that every invalid field will be marked (and will display a border red if applicable)
   * @param {FormGroup} formGroup
   */
  protected static validateForm(formGroup: UntypedFormGroup): void {
    /**
     * Object.values is not compatible with IE browser.
     * We will just get all the keys, loop through it, and get the form control using the key.
     */
    for (const field in formGroup.controls) {
      if (formGroup.get(field)) {
        const control = formGroup.get(field) as any;
        control.markAsTouched();

        if (control.controls) {
          control.controls.forEach(c => FormEditorBase.validateForm(c));
        }
      }
    }
  }

  constructor() {
  }

  /**
   * Method to update the user's address based on the google search result.
   * @param {LocationResult} result - google search result.
   */
  public updateAddresses(result: LocationResult): void {
    if (isNullOrUndefined(result.streetNumber)) {
      this.form.controls.address.setValue(result.street);
    } else {
      this.form.controls.address.setValue(`${result.streetNumber} ${result.street}`);
    }
    this.form.controls.city.setValue(result.city);
    this.form.controls.state.setValue(result.state);
    this.form.controls.country.setValue(result.countryCode);
    this.form.controls.zipCode.setValue(result.postalCode);
  }
}
